require("@rails/ujs").start()
import 'popper.js';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.css';
import datepicker from 'bootstrap-datepicker';
import select2 from 'select2';
import 'select2/dist/css/select2.css';
import '../stylesheets/application.scss';
import bootstrapPaginator from 'bootstrap-paginator/bootstrap-paginator';

import '../text_editing';
import '../navigation';
import '../map_index';
import '../dashboard';
import '../record';
